import http from "../../services/httpService";


export const searchChanges      =  async (payload) => await http.post('/search_changes/', payload);
export const searchChangeEntity =  async (payload) => await http.post('/search_change_entity/', payload);
